import moment from "moment";
import angular from "angular";

class LeaveService {
  constructor($http, $rootScope, TimesheetService, SettingsService) {
    "ngInject";
    this.$http = $http;
    this.baseUrl = $rootScope.apiHost + "/api/leave/me";
    this.leaveTypes = null;
    this.isSalary = null;
    this.timesheetService = TimesheetService;
    this.settingsService = SettingsService;
    this.currentTsLeaveDiffValues = {}
  }


  autoBalanceLeave(timeEntry) {
       
    let nonLeaveDailyTotal = 0;

    // Get all time entries for this date (including the one being edited)
    this.timesheetService.currentTimesheet.timeEntries.forEach( (te) => {
      if (te && te.date && moment(te.date).isSame(moment(timeEntry.date), 'day') && te.chargeCode.id !== window.Utilities.AUTO_BALANCE_CHARGE_CODE_ID() && !te.chargeCode.leaveType) {
        if (te === timeEntry || (te.chargeCode.id === timeEntry.chargeCode.id && moment(te.date).isSame(moment(timeEntry.date), 'day'))) {
          nonLeaveDailyTotal += (timeEntry.hours || 0);
        } else {
          nonLeaveDailyTotal += (te.hours || 0);
        }
      }
    });
    
   
    let requiredLeaveAdjustments = window.Utilities.WORKDAY_HOURS() - nonLeaveDailyTotal;

    // Check if the timeEntry date is a weekend day (Saturday = 6, Sunday = 0)
    const entryDate = moment(timeEntry.date);
    const dayOfWeek = entryDate.day(); // 0 = Sunday, 6 = Saturday
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    let leaveEntry = this.timesheetService.getTimeEntryForDateAndChargeCode(timeEntry.date, window.Utilities.AUTO_BALANCE_CHARGE_CODE_ID());

    if(!leaveEntry) {
      this.timesheetService.currentTimesheet.addChargeCode(this.settingsService.autoBalanceLeaveChargeCode);
      leaveEntry = this.timesheetService.getTimeEntryForDateAndChargeCode(timeEntry.date, this.settingsService.autoBalanceLeaveChargeCode.id);
    }

    if(isWeekend){   
      console.log('isWeekend', isWeekend, timeEntry.hours, requiredLeaveAdjustments);
      requiredLeaveAdjustments = nonLeaveDailyTotal * -1;
    }

    leaveEntry.hours = requiredLeaveAdjustments;
    leaveEntry.mode = this.timesheetService.getMode(leaveEntry);
  }



  getPtoForUser() {
    return this.$http.get(this.baseUrl, {withCredentials: true})
  }

  refreshPto() {
    let self = this;
    this.getPtoForUser().then((res) => {
      self.leaveTypes = res.data;
      for(let i=0;i<self.leaveTypes.length;i++) {
        //initialize the selected year to the current year
        self.leaveTypes[i].selectedLeaveYear = moment().year();
      }

    }, (err) => {
      self.isSalary = false;
    });
  }

  updateTimesheetLeaveDiffs(currTs, persistedTs) {
    const leaveDiffByDay = {}
    let totalDiff = 0

    if (currTs.dataDirty) {
      // NOTE: Right now assumes leave is PTO, will break if we have multiple leave charge codes
      currTs.timeEntries.forEach((te, i) => {
        // We only care about leave types
        if (!te.chargeCode.leaveType) return

        const persistedTe = persistedTs.timeEntries[i] || {}

        const currHours = te.hours || 0
        const persistedHours = persistedTe.hours || 0
        const diff = currHours - persistedHours

        // TODO: We aren't considering multiple leave types here. This will need to change
        // if the theoretical case of multiple leave type becomes a reality.
        if (currHours !== persistedHours) {
          leaveDiffByDay[te.date] = {
            value: currHours,
            diff,
          }

          totalDiff += diff
        }
      })

      this.currentTsLeaveDiffValues = {
        leaveDiffByDay,
        diff: totalDiff,
      }
    } else {
      // console.log('resetting currentTsValues')
      this.currentTsLeaveDiffValues = {}
    }
    // console.log('currentTsLeaveDiffValues', this.currentTsLeaveDiffValues)

    // TODO: Assumption that we only have 1 leave type
    // if (this.leaveTypes) {
    //   this.calculateLeaveTypePtoStats(this.leaveTypes[0])
    // }

    return Promise.resolve()
  }

  /**
   * Calculate current leave statistics based on latest leave data.
   *
   * @param {*} leaveType
   */
  calculateLeaveTypePtoStats(leaveType, leaveTypeYear) {
    let leaveStats = {}

    if(leaveType) {
      const year = leaveTypeYear || leaveType.selectedLeaveYear

      const yearData = leaveType.leaveHoursByYear[year] || {};
      const balance = this.getTotalCurrentBalanceForYear(leaveType, year) || 0;
      const projectedBalance = this.getProjectedBalance(leaveType) || 0;
      const prevYearBalance = this.getLeaveBalanceForYear(leaveType, year - 1) || 0;
      const totalLeaveTaken = this.getTotalLeaveTaken(leaveType, year) || 0;
      
      leaveStats = {
        selectedYear: year,
        balance: parseFloat(balance).toFixed(2),
        projectedBalance: parseFloat(projectedBalance).toFixed(2),
        initialBalance: parseFloat(prevYearBalance).toFixed(2),
        prevYearBalance: parseFloat(prevYearBalance).toFixed(2),
        timeOffBenefit: yearData.timeOffBenefit ? parseFloat(yearData.timeOffBenefit).toFixed(2) : '0.00',
        accrualRate: yearData.accrualRate ? parseFloat(yearData.accrualRate).toFixed(2) : '0.00',
        accruedBalance: yearData.accruedBalance ? parseFloat(yearData.accruedBalance).toFixed(2) : '0.00',
        totalLeaveTaken: parseFloat(totalLeaveTaken).toFixed(2),
        remainingPerWeek: this.remainingPerWeek(leaveType),
        remainingWeeks: this.remainingWeeks(),
        leaveTakenByDay: yearData.leaveTakenByDay || [],
        nonLeaveHours: yearData.nonLeaveHours ? parseFloat(yearData.nonLeaveHours).toFixed(2) : '0.00',
        expectedWorkingHours: yearData.expectedWorkingHours ? parseFloat(yearData.expectedWorkingHours).toFixed(2) : '0.00',
        leaveAdjustments: yearData.leaveAdjustments ? parseFloat(yearData.leaveAdjustments).toFixed(2) : '0.00',
      }

      // If its the current year, apply daily diffs to leaveTakenByDay
      if (this.isCurrentYear(year) && this.currentTsLeaveDiffValues.leaveDiffByDay) {

        // For each diff, replace the corresponding value in leaveTakenByDay but the current value
        Object.keys(this.currentTsLeaveDiffValues.leaveDiffByDay).forEach((dateStr) => {
          // Convert from date string to GMT millis
          const millis = this.getMidnightGMTMillis(dateStr)

          const matchedDiffDayMillis = Object.keys(leaveStats.leaveTakenByDay).find((dayMillis) =>
            dateStr === moment(dayMillis * 1000).format('YYYY-MM-DD')
          )

          const latestValue = this.currentTsLeaveDiffValues.leaveDiffByDay[dateStr].value

          // If we have a match, replace with the current value
          if (matchedDiffDayMillis) {
            leaveStats.leaveTakenByDay[matchedDiffDayMillis] = latestValue
          }
          // If we don't have a match add a new entry
          else {
            leaveStats.leaveTakenByDay[millis / 1000] = latestValue
          }
        })
      }
    }

    // console.log('leaveStats', leaveStats)

    return leaveStats
  }

  getProjectedBalance(leaveType) {
    let possibleAccrual = leaveType.leaveHoursByYear[leaveType.selectedLeaveYear].timeOffBenefit;
    let lastYearBalance = this.getLeaveBalanceForYear(leaveType,leaveType.selectedLeaveYear - 1, this.currentTsLeaveDiffValues);
    let ptoTaken = this.getTotalLeaveTaken(leaveType, leaveType.selectedLeaveYear, this.currentTsLeaveDiffValues)
    return (possibleAccrual - ptoTaken) + lastYearBalance;
  }

  getLeaveBalanceForYear(leaveType, targetYear) {
    let leaveBalance = 0;

    const self = this
    _.forEach(leaveType.leaveHoursByYear, function(data, year) {

      if(year <= targetYear) {
        const totalLeaveTaken = self.getTotalLeaveTaken(leaveType, year)
        leaveBalance += data.accruedBalance - totalLeaveTaken + data.leaveAdjustments;
      }
    });

    return leaveBalance;
  }

  /**
   * Utility method to consider unsaved leave taken changes into current year calculation.
   *
   * @param {*} leaveType
   * @param {*} year
   * @returns
   */
  getTotalLeaveTaken(leaveType, year) {
    if (!year) {
      year = leaveType.selectedLeaveYear
    }

    let totalLeaveTaken = leaveType.leaveHoursByYear[year].totalLeaveTaken

    // If its the current year, check if there are any diffs in the current timesheet
    if (this.isCurrentYear(year) && this.currentTsLeaveDiffValues.leaveDiffByDay) {
      totalLeaveTaken += this.currentTsLeaveDiffValues.diff
    }

    // console.log('getTotalLeaveTaken() year', year, totalLeaveTaken, this.currentTsLeaveDiffValues)

    return totalLeaveTaken
  }

  getTotalCurrentBalanceForYear(leaveType, targetYear) {
    let leaveBalance = 0;
    _.forEach(leaveType.leaveHoursByYear, function(data, year) {
      if(year <= targetYear) {
        leaveBalance += data.endingBalance;
      }
    });

    // If it is the current year, add any unsaved values
    if (this.isCurrentYear(targetYear)) {
      leaveBalance -= this.currentTsLeaveDiffValues.diff || 0
    }

    return leaveBalance
  }

  isCurrentYear(year) {
    return parseInt(moment().year()) === parseInt(year)
  }

  remainingWeeks() {
    let today = moment(),
      endOfYear = moment().endOf("year");
    let weeks = endOfYear.diff(today, "week");
    return weeks === 0 ? 1 : weeks;
  }

  remainingDays() {
    let today = moment(),
      endOfYear = moment().endOf("year");
    let days = endOfYear.diff(today, "days");
    return days === 0 ? 1 : days;
  }

  remainingPerDay(currentBalance) {
    return Number(currentBalance / this.remainingDays()).toFixed(1).toString();
  }

  remainingPerWeek(leaveType) {
    let projectedPtoBalance = this.getProjectedBalance(leaveType);
    return Number(projectedPtoBalance / this.remainingWeeks()).toFixed(2).toString();
  }

  getMidnightGMTMillis(dateStr) {
    let midnightGMTDate = new Date(dateStr)
    midnightGMTDate.setUTCHours(0, 0, 0, 0)

    return midnightGMTDate.getTime()
  }

}

export default angular.module('leaveservice', []).service('LeaveService', LeaveService);



// WEBPACK FOOTER //
// ./client/pages/timesheet/services/leave.service.js